<template>
  <div>
    <div class="mx-md-8 mx-0">
      <v-simple-table>
        <template v-slot:default>
          <tbody class="black--text">
            <tr>
              <td class="font-weight-regular pl-6">Applicant 1 premium</td>
              <td class="font-weight-regular text-right pr-6">
                {{ price.Values.Applicant1Premium | formatCurrency }}
              </td>
            </tr>
            <template v-if="price.Values.Applicant2Premium">
              <tr>
                <td class="font-weight-regular pl-6">Applicant 2 premium</td>
                <td class="font-weight-regular text-right pr-6">
                  {{ price.Values.Applicant2Premium | formatCurrency }}
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
      <div
        class="limedSpruce white--text pa-2 d-flex font-weight-bold justify-space-between px-6 font-18"
      >
        <span>Total monthly payment</span>
        <span>
          {{ price.Values.TotalCostPerPaymentPeriod | formatCurrency }}
        </span>
      </div>
    </div>

    <p class="mx-md-8 mx-4 mt-md-4 mt-2">
      <b>Note:</b> All premiums are inclusive of Insurance Premium Tax at the
      current rate and may be subject to review.
    </p>

    <h5 class="font-weight-bold pr-6 mt-6 mx-md-8 mx-4 mb-4 font-20">
      Cost projection
    </h5>

    <div class="mx-md-8 mx-0">
      <div
        class="limedSpruce white--text pa-2 d-flex font-weight-bold justify-space-between px-6 font-18"
      >
        <span>Number of years</span>
        <span>Total cost</span>
      </div>
      <v-simple-table>
        <template v-slot:default>
          <tbody class="black--text">
            <tr>
              <td class="font-weight-regular pl-6">1 year</td>
              <td class="font-weight-regular text-right pr-6">
                {{ price.Values.AnnualPremiumIncludingIPT | formatCurrency }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-regular pl-6">5 years</td>
              <td class="font-weight-regular text-right pr-6">
                {{ price.Values.FiveYearPremiumIncludingIPT | formatCurrency }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
    </div>

    <p class="mx-4 mx-md-8 mt-4 mb-0">
      The annual and five year projection is an estimate and has been calculated
      using the monthly cost. To calculate the premium over the term of the
      mortgage, simply multiply your annual cost by the number of years
      outstanding on your mortgage agreement or the number of years until you
      reach the age of 65, whichever occurs first.
    </p>
  </div>
</template>

<script>
export default {
  props: {
    breakdownModel: [Array, Object],
  },
  computed: {
    price() {
      return this.breakdownModel.price;
    },
    premium() {
      return this.breakdownModel.premium;
    },
  },
};
</script>

<style lang="scss" scoped>
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}

tr:nth-of-type(odd) {
  background-color: var(--v-whitesmoke-base);
}
</style>
